var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.35 4a.5.5 0 000-.71L27.17.15a.5.5 0 00-.71 0 .5.5 0 000 .7l2.83 2.83-2.83 2.83a.5.5 0 10.71.71zM0 4.18h30v-1H0z"}));
}

Arrow.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 30.5 7.36"};

module.exports = Arrow;

Arrow.default = Arrow;
